export const hasPermission = (item) => {
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  if (userDetails) {
    let role = userDetails["user"]["role"];
    switch (item) {
      case "DOWNLOADS":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPPORT" ||
          role === "SUPERUSER" || role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "CREATE_APP":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "AGENT" ||
          role === "SUPERUSER" ||
          role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "POLICY":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPPORT" ||
          role === "SUPERUSER"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "USERS":
        if (role === "SUPERADMIN" || role === "ADMIN") {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "PRODUCT_UIN":
        return role === "SUPERADMIN" || role === "ADMIN";
      case "UPLOAD_IFSC":
        if (role === "SUPERADMIN" || role === "ADMIN" || role === "SUPERUSER") {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "UPLOAD_FINCARE":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "OPERATIONS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "PROPOSAL_DETAILS":
        if (role === "SUPERADMIN" || role === "ADMIN" || role === "SUPERUSER" || role === "POS") {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "OPERATIONS":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPPORT" ||
          role === "SUPERUSER" || role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "FILE_UPLOAD":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPERUSER" ||
          role === "OPERATIONS" ||
          role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "LOGS_DETAILS":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPPORT" ||
          role === "SUPERUSER" || role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "INSTAVERIFY_DETAILS":
        if (
          role === "SUPERADMIN" ||
          role === "ADMIN" ||
          role === "SUPPORT" ||
          role === "SUPERUSER" || role === "POS"
        ) {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "SWITCH_API":
        if (role === "SUPERADMIN" || role === "ADMIN" || role === "POS") {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      case "PAYMENTS":
        if (role === "SUPERADMIN" || role === "ADMIN" || role === "SUPERUSER" || role === "POS") {
          return true;
        } else if (role === "MAKER" || role === "CHECKER") {
          return false;
        } else {
          return false;
        }
      // case 'REPORTS':
      // if (true) {  // value is true since roles are not specified yet.
      //   return true
      // } else {
      //   return false
      // }
      case "D2C_OFFLINE":
        return role === "MAKER" || role === "CHECKER";

      /*-------------Need to add roles for blue chip-----------------*/
      case "BLUE_CHIP_USER":
        return role === "BLUECHIPUSER";
      case "BLUE_CHIP_ADMIN":
        return role === "ADMIN";
      case "UPFRONT_USER":
        return role === "OPERATIONS";
      case "SETTINGS":
        return role === "OPERATIONS";
      case "UPFRONT_PAYMENT_REPORT":
        return role === "SUPERUSER" || role === "OPERATIONS" || role === "SUPPORT" ;
        case "POS":
          return role === "POS";
      default:
        return false;
    }
  } else {
    return false;
  }
};
